/**
 * GitHub URL parsing utilities
 */

/**
 * Parse GitHub URL or "owner/repo" shorthand into owner and repo components.
 * Handles: "owner/repo", "https://github.com/owner/repo", "github.com/owner/repo.git"
 */
export function parseGitHubUrl(input: string): { owner: string; repo: string } {
  input = input.trim();

  // Try URL patterns first
  const urlPattern = /^(?:https?:\/\/)?github\.com\/([^\/]+)\/([^\/\?\#]+)/;
  const match = input.match(urlPattern);
  if (match) {
    return { owner: match[1], repo: match[2].replace(/\.git$/, '') };
  }

  // Try "owner/repo" shorthand (reject if owner contains '.', e.g. "github.com/owner")
  const shortPattern = /^([^\/]+)\/([^\/]+)$/;
  const shortMatch = input.match(shortPattern);
  if (shortMatch && !shortMatch[1].includes('.')) {
    return { owner: shortMatch[1], repo: shortMatch[2].replace(/\.git$/, '') };
  }

  throw new Error(
    `Invalid GitHub URL or shorthand: "${input}". Expected "owner/repo" or "https://github.com/owner/repo"`
  );
}
